import React from 'react';
import warehouseCeoLogo from '../assets/warehouse_ceo_logo.jpg';
import './SplashScreen.css';

const SplashScreen = () => {
    return (
        <div className="splash-screen">
            <div className="splash-content">
                <img
                    src={warehouseCeoLogo}
                    alt="Warehouse CEO"
                    className="splash-logo"
                />
                <div className="splash-loader">
                    <div className="spinner"></div>
                </div>
            </div>
        </div>
    );
};

export default SplashScreen;
